/**
 * customFieldSOrt filter used for sorting custom fields
 */
angular.module('bookingApp').filter('customFieldSort', customFieldSort);
function customFieldSort(){
    return function(input){
        var outter = [];
        outter = Object.keys(input).map(function(k){
            return(input[k]);
        });
        outter.sort(function(a, b){
            if(a.type === 5 && b.type === 5){
                if(a.readOnly && b.readOnly){
                    return 0;
                }
                if(a.readOnly){
                    return -1;
                }
                if(b.readOnly){
                    return 1;
                }
            }
            if(a.type === 2 && b.type === 5){
                return -1;
            }
            if(a.type === 4 && b.type === 2){
                return 1;
            }
            if(a.type === 5){
                return -1;
            }
            else return 0;
        });
        return outter;
    }
}